module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/article-1df86335fc373262908fd4988cd54af6.png";